import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { Dictionary } from '../../../../shared/models/dictionary';

export const DictionaryBrandEditActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[dictionary/brand] Edit'),
  requestFail: uniqueActionType('[dictionary/brand] Edit fail'),
  requestSuccess: uniqueActionType('[dictionary/brand] Edit success'),
  requestClearErrors: uniqueActionType('[dictionary/brand] Edit clear errors'),
  requestClear: uniqueActionType('[dictionary/brand] Edit clear')
};

export class DictionaryBrandEditAction implements PayloadAction {
  readonly type = DictionaryBrandEditActionTypes.request;

  constructor(public payload: SendByIdPayload<Dictionary>) {
  }
}

export class DictionaryBrandEditFailAction implements PayloadAction {
  readonly type = DictionaryBrandEditActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DictionaryBrandEditSuccessAction implements PayloadAction {
  readonly type = DictionaryBrandEditActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class DictionaryBrandEditClearErrorsAction implements PayloadAction {
  readonly type = DictionaryBrandEditActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryBrandEditClearAction implements PayloadAction {
  readonly type = DictionaryBrandEditActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
